<p-dropdown [options]="options" [ngModel]="value" (ngModelChange)="select($event)" [disabled]="disabled"
  (onBlur)="onTouched()" optionLabel="label" optionValue="value" [showClear]="true" [placeholder]="placeholder"
  styleClass="w-full" appendTo="body">
  <ng-template pTemplate="selectedItem">
    <span class="flex align-items-center gap-2">
      <span class="colour-swatch" [style.background]="selectedHex"></span>
      {{ selectedLabel }}
    </span>
  </ng-template>
  <ng-template let-opt pTemplate="item">
    <span class="flex align-items-center gap-2">
      <span class="colour-swatch" [style.background]="opt.hex"></span>{{ opt.label }}
    </span>
  </ng-template>
</p-dropdown>
